module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "body_Body-Left"
  }, [_vm._v("Welcome to fifty-two weeks of living with intention. "), _c('span', {
    staticClass: "BookItalics _idGenCharOverride-2"
  }, [_vm._v("Black and Resilient: 52 Weeks of Anti-Racist Activities for Black Joy and Empowerment ")]), _vm._v("was designed to help you get motivated to make real changes to your life and your way of"), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("thinking.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body-Left"
  }, [_vm._v("I grew up in Haiti, a Black nation led by Black people. The people of Haiti do not experience racism as it exists in the United States; what presents itself mostly there is colorism (prejudice against individuals with a darker skin tone, among people of the same ethnic or racial group). Imagine my shock and surprise when I immigrated to the United States and, on top of having to deal with a new language and culture, discovered that I was often singled out for the color of my skin, whether it was a group of kids who threw a milkshake at me, or a college professor who assumed I was lazy because I fell behind in my work trying to keep up with the language. Then, as I worked on assimilating, I began to witness the reality of being Black and living in Black skin. While Black women like me deal with racist attitudes daily, Black boys and Black men specifically seem to live in perpetual danger. In a white world, they are seen as a threat and are easily targeted and often murdered by the authorities that should be serving and protecting all"), _c('span', {
    staticClass: "noBreak"
  }), _vm._v("co"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("mmunities.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body-Left"
  }, [_vm._v("Throughout my years working as an educator, I’ve seen firsthand the kind of damage that racism can do to a young person’s spirit. The effects of racism are real and damaging. I’ve seen many promising students become disengaged and withdrawn because of racist incidents. I know the perils of the school to prison pipeline which disproportionately affects Black and Brown boys. I’ve also seen the real beauty of students who overcame the struggles of racism and became strong, confident, and comfortable in their own power, and were able to become successful in their classes and th"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("eir")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("lives.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body-Left"
  }, [_c('span', {
    staticClass: "BookItalics _idGenCharOverride-2"
  }, [_vm._v("Black and Resilient")]), _vm._v(" is a book about the realities of being Black. It leads Black boys and young Black men to a better understanding of the effects of racism and teaches them how to navigate various spaces. This book is a guide filled with activities and prompts that encourage empowerment and self-reliance, providing you with tools for combating racism in your daily life. There is no doubt you are powerful, but, unfortunately, you’ll face microaggressions and outright racism in your daily life, be it while jogging down the road like Ahmaud Arbery or walking down the street with a bag of Skittles like Trayvon Martin, or during a traffic stop while driving like Philando Castile. "), _c('span', {
    staticClass: "BookItalics _idGenCharOverride-2"
  }, [_vm._v("Black and Resilient")]), _vm._v(" will help empower you to be brave, face the challenges of oppression, and rely on"), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("yourself.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body-Left"
  }, [_vm._v("Learn"), _c('span', {
    staticClass: "noBreak"
  }), _vm._v("to:")]), _vm._v(" "), _c('p', {
    staticClass: "body_Bullets"
  }, [_c('span', {
    staticClass: "_idGenBNMarker-1"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("Understand and combat racism and microaggressions in your daily life.")]), _vm._v(" Once you identify how racism affects your physical and mental health, you can love and take care of"), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("yourself.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Bullets"
  }, [_c('span', {
    staticClass: "_idGenBNMarker-1"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("Become a leader in your community.")]), _vm._v(" To become a well-rounded Black boy is to become an important member of your society. This journal and activity workbook guides you through achieving your personal and pub"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("lic")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("goals.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Bullets"
  }, [_c('span', {
    staticClass: "_idGenBNMarker-1"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("Be brave, empowered, and self-reliant.")]), _vm._v(" Being a Black boy comes with many gifts, one being resiliency. While you are strong and can overcome anything, be kind to"), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("yourself.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body-Left"
  }, [_vm._v("I’ve paired twenty-six lessons in anti-racism with fifty-two writing exercises. These exercises will open your mind to the world around you, and the world within you. As you go through these activities, keep in mind that you are developing a practice, a foundation of mindful activity you can build on for the future. These activities don’t have to stop after the year is over. I hope journaling and anti-racist awareness will become part of your daily rituals"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" for")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("life.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body-Left"
  }, [_vm._v("These writing exercises were adapted from narrative therapy techniques that have been shown to increase confidence and lower anxiety and depression as well as increase motivation and self-knowledge—something every resilient Black boy needs. Being resilient isn’t something we are born with; it’s a learned trait. And sometimes you snap a little. It’s okay to break down, but getting back up is what makes you resilient and"), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("powerful.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body-Left"
  }, [_vm._v("The anti-racist chapters are part of an education every Black boy should have in the truth of the situation-at-large. They will equip you with the knowledge you need to navigate these trying times in a society that’s not built to accommodate Blackness. The lessons will help you understand how our society works and how you can fight back against inequity and injustice in a safe and productive way. You "), _c('span', {
    staticClass: "BookItalics _idGenCharOverride-2"
  }, [_vm._v("can ")]), _vm._v("fight back against injustice. It’s a battle brave boys are fighting all over "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("world.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body-Left"
  }, [_vm._v("As you start this journey, I’m excited to know that you will be exploring and learning about yourself and the world. I hope you enjoy the process and come out of the year ready to take on whatever life has to offer you in terms of fulfilling your dreams. Remember to "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("dream")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("big!")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39e88cba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlackAndResilient5.vue
// module id = 75
// module chunks = 0